export default __webpack_public_path__ + "static/cardma-09375169ce893780983d85b4befc4f2a.png";